import { useContext } from 'react';
import { AuthContext } from './AuthProvider';
export var useAuth = function useAuth() {
  var context = useContext(AuthContext);

  if (!context) {
    var missingContextError = function missingContextError() {
      throw new Error('authApi was called without being inside an AuthProvider');
    };

    return {
      isLoading: true,
      isAuthenticated: false,
      isLoggedIn: false,
      currentUser: undefined,
      authApi: {
        login: missingContextError,
        logout: missingContextError,
        getIdToken: function getIdToken() {
          return Promise.resolve(undefined);
        },
        getAccessToken: function getAccessToken() {
          return Promise.resolve(undefined);
        },
        getSession: function getSession() {
          return Promise.resolve(false);
        },
        forgotPassword: missingContextError,
        verifyRecoveryToken: missingContextError
      }
    };
  }

  var isLoading = context.isLoading,
      isAuthenticated = context.isAuthenticated,
      isLoggedIn = context.isLoggedIn,
      currentUser = context.currentUser,
      authApi = context.authApi,
      config = context.config;
  return {
    isLoading: isLoading,
    isAuthenticated: isAuthenticated,
    isLoggedIn: isLoggedIn,
    currentUser: currentUser,
    authApi: authApi,
    config: config
  };
};